<div class="no-data-available-box bg-white">
  <img src="assets/images/icon/empty.svg" alt="empty" class="mb-4" style="width: 100px;" />
  <h4 class="text-primary">{{ texto ? texto : 'Nenhum registro foi encontrado.' }}</h4>
</div>
